(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[84860],{

/***/ 33161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28034);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var ScrollingGallery = function(param) {
    var photos = param.photos;
    var imageUrls = (photos || []).map(function(asset) {
        return (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getImage */ .gJ)(asset);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: Array.from({
            length: 4
        }).map(function(_, i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().scrollingEl),
                children: imageUrls === null || imageUrls === void 0 ? void 0 : imageUrls.map(function(photo, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().photo), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["photo-".concat(index + 1)]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: photo.url,
                            alt: photo.alt,
                            layout: "fill",
                            loader: function(param) {
                                var src = param.src;
                                return src;
                            },
                            objectFit: "cover",
                            priority: true,
                            unoptimized: true
                        })
                    }, "photo-".concat(index + 1));
                })
            }, i);
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ScrollingGallery);


/***/ }),

/***/ 28034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jX2G1","scrollingEl":"styles_scrollingEl__iZn4p","image-scroll":"styles_image-scroll__Dbln7","photo":"styles_photo__hhKRJ","photo-1":"styles_photo-1__pLFTR","photo-3":"styles_photo-3__I7U2t","photo-5":"styles_photo-5__RJ6K2","photo-2":"styles_photo-2__pIC9z","photo-6":"styles_photo-6__yOUw2","photo-4":"styles_photo-4__SbbyV","blinking":"styles_blinking__LQK74","swing":"styles_swing__J_gLR","animateborder":"styles_animateborder__g4jXO","animateborder-overlay":"styles_animateborder-overlay__lTPEs","animatecircle":"styles_animatecircle__oBfTD","animatedot":"styles_animatedot__cUJZb","animStar":"styles_animStar__izaQC","hideText":"styles_hideText__wb_XE","spin":"styles_spin__6iPNc","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__yFgVk","outOfTransparencyMobile":"styles_outOfTransparencyMobile__Ji9Td","appearance":"styles_appearance__Im8mB","appearanceFromBelow":"styles_appearanceFromBelow___dyS9","flicker":"styles_flicker__WovMJ","vibrate1":"styles_vibrate1__Qjekc","rocket":"styles_rocket__eMlcJ","burgerItem1":"styles_burgerItem1__tKhVX","burgerItem2":"styles_burgerItem2__qsa3p","burgerItem3":"styles_burgerItem3__TkTub","burgerItem1Reverse":"styles_burgerItem1Reverse__0w5a2","burgerItem2Reverse":"styles_burgerItem2Reverse__v7lcH","burgerItem3Reverse":"styles_burgerItem3Reverse__7D9IO","arrow-down":"styles_arrow-down__H8Uld","image-scroll-reverse":"styles_image-scroll-reverse__M_LB5","stickerbox-pointer-move":"styles_stickerbox-pointer-move__gyVY4","hide-image":"styles_hide-image__Zqzta","stickerbox-pointer-second":"styles_stickerbox-pointer-second__LKDn8","stickerbox-pointer-third":"styles_stickerbox-pointer-third__RoQei","cedar-bounce":"styles_cedar-bounce__BHQzs"};

/***/ })

}]);